
import { defineComponent } from '@vue/runtime-core'
import ExpandedText from '@/components/elements/ExpandedText.vue'

export default defineComponent({
  components: {
    ExpandedText
  },

  props: {
    person: {
      type: String,
      default: ''
    },
    message: {
      type: String,
      required: true
    }
  }
})
